/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class OpenapiService {

    constructor(public readonly httpRequest: BaseHttpRequest) {}

    /**
     * Real Asset Config Schema
     * @returns any Successful Response
     * @throws ApiError
     */
    public realAssetConfigSchema(): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/codegen/schema/real_asset_config.json',
        });
    }

}
